import React from "react"
import { SidebarContainer, Icon, CloseIcon, SidebarLink, SidebarWrapper, SidebarMenu } from './sidebarStyled'

const Sidebar = ({ isOpen, toggle }) => {
    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink to="sobre" onClick={toggle}>
                        Sobre mim
                    </SidebarLink>
                    <SidebarLink to="formacao" onClick={toggle}>
                        Formação
                    </SidebarLink>
                    <SidebarLink to="certificacao" onClick={toggle}>
                        Certificações
                    </SidebarLink>
                    <SidebarLink to="experiencia" onClick={toggle}>
                        Experiência profissional
                    </SidebarLink>

                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>

    );
};

export default Sidebar